import trimStart from 'lodash-es/trimStart';

export const required = value => (
  value || typeof value === 'number' ? undefined : "필수 입력 항목입니다."
);

export const trimLeft = value => value && trimStart(value);
